<script setup lang="ts">
import type { IntegrationGroup } from '@KTXC/types/integrationTypes';
import { t } from '@KTXC/composables/useL10n';
import LayoutSystemMenuItem from './LayoutSystemMenuItem.vue';

const props = defineProps<{ group: IntegrationGroup }>();
</script>

<template>
  <v-list-subheader color="lightText" class="smallCap text-subtitle-2">{{ t(props.group.l10n, props.group.label) }}</v-list-subheader>
  <LayoutSystemMenuItem
    v-for="(item, i) in props.group.items"
    :key="i"
    :item="item"
  />
</template>
